// Librerias
import React from 'react'
let PropTypes = React.PropTypes
// CSS
import * as css from './TablaInventarios.css'
// Componente
import { RowInventario } from './RowInventario.jsx'

export class TablaInventarios extends React.Component{
    render(){
        let totalInventarios = this.props.inventarios.length
        return <div className="row">
            <TablaInv>
                {_.range(0, totalInventarios).map(index=>{
                    let inventario = this.props.inventarios[index]
                    return <RowInventario
                        ref={index}
                        key={inventario? inventario.inv_idInventario : index}
                        inventario={inventario}
                        correlativo={''+(index+1)}
                    />
                })}
                <RowInventario
                    correlativo={"T"}
                    valorNeto = {this.props.valorNeto}
                />
            </TablaInv>
        </div>
    }
}
TablaInventarios.propTypes = {
}
let TablaInv = ({children})=>
    <div className={'panel panel-primary'}>
        <div className={'panel-heading'}>
            <span className={'glyphicon glyphicon-ok'}/>
            {' Servicios realizados'}
        </div>
        <table className={'table table-striped table-hover no-margin table-condensed '+css.tablaInventariosFCV}>
            <thead>
            <tr>
                <th className={css.thCorrelativo}>#</th>
                <th className={css.thFecha}>Fecha IG</th>
                <th className={css.thNombreCliente}>Cliente</th>
                <th className={css.thNumeroLocal}>Ceco</th>
                <th className={css.thNombreLocal}>Local</th>
                <th className={css.thUndSEI}>Disc. Teórico</th>
                <th className={css.thUndInf}>Und. Informadas</th>
                <th className={css.thUndInf}>Und. Contadas</th>
                <th className={css.thUndSEI}>$ Unitario</th>
                <th className={css.thUndSEI}>Total Servicio</th>
            </tr>
            </thead>
            <tbody>
            {children}
            </tbody>
        </table>
    </div>


// WEBPACK FOOTER //
// ./frontEnd/inventarios/inventarios-facturacion/peticionOC/TablaInventarios.jsx